/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CenterNoticeDto } from '../../models/center-notice-dto';
import { CreateCenterNoticeDto } from '../../models/create-center-notice-dto';

export interface CenterNoticeControllerCreate$Params {
  centerId: string;
      body: CreateCenterNoticeDto
}

export function centerNoticeControllerCreate(http: HttpClient, rootUrl: string, params: CenterNoticeControllerCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<CenterNoticeDto>> {
  const rb = new RequestBuilder(rootUrl, centerNoticeControllerCreate.PATH, 'post');
  if (params) {
    rb.query('centerId', params.centerId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CenterNoticeDto>;
    })
  );
}

centerNoticeControllerCreate.PATH = '/api/center-notice/center';
